var _title, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.07318563990116127,17.45525413523822 C-0.011734360098838789,17.705497067451162 -0.0230123600988388,17.975172151432147 0.04070963990116132,18.231676554770342 C0.10443563990116127,18.48828891450725 0.24043563990116124,18.720826997331528 0.4323656399011615,18.901438052375642 C0.4323656399011615,18.901438052375642 1.173185639901161,19.240313187930607 1.5099256399011614,18.901438052375642 L2.138495639901161,18.268705599528342 V34.89960473381124 C2.138495639901161,34.89960473381124 2.053815639901161,35.89388316594289 3.036455639901161,35.89388316594289 H13.36301563990116 V23.3302413531106 C13.36301563990116,23.3302413531106 13.345715639901162,22.607257350940596 14.261015639901162,22.607257350940596 H21.35481563990116 C21.35481563990116,22.607257350940596 22.16301563990116,22.434743025799843 22.16301563990116,23.420708815230718 V35.89388316594289 H32.57931563990116 C32.57931563990116,35.89388316594289 33.38751563990116,35.9699924270344 33.38751563990116,35.08043170165276 V18.268705599528342 L34.01611563990116,18.991797558097048 C34.01611563990116,18.991797558097048 34.66901563990116,19.328837434873922 35.27321563990116,18.720611084534106 C35.27321563990116,18.720611084534106 35.92611563990116,17.931665722751465 35.45281563990116,17.45525413523822 L18.48141563990116,0.3724279246698158 C18.48141563990116,0.3724279246698158 17.877115639901163,-0.46553503994772 17.04461563990116,0.3724279246698158 L0.07318563990116127,17.45525413523822 z",
    fill: "#ffffff",
    id: "svg_1",
    className: "",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconActive);
export default __webpack_public_path__ + "static/media/home-icon-active.322b0508413125dc110086538f023eda.svg";
export { ForwardRef as ReactComponent };